<template>
  <div class="app-reset-password-confirm-password">
    <form @submit.prevent="save">
      <fieldset>
        <legend class="text-xl visually-hidden">Passwort zurücksetzen</legend>
        <div class="inputs-container">
          <div class="input-field">
            <label class="text-base-medium mandatory" :for="'birthdate' + _uid">
              <slot name="lblBirthdate">Geburtsdatum</slot>
            </label>
            <ValidationIndicator :dirty="$v.birthdate.$dirty" :valid="!$v.birthdate.$invalid">
              <input
                :id="'birthdate' + _uid"
                v-model="birthdate"
                type="text"
                name="birthdate"
                required
                class="input"
                :class="{ error: !isValid('birthdate') }"
                @input="$v.birthdate.$touch"
                placeholder="TT.MM.JJJJ  (z.B. 10.12.1988)"
                autocomplete="off"
                aria-describedby="birthdate-hint"
              />
            </ValidationIndicator>
            <small id="birthdate-hint" class="sr-only">
              <p>
                Bitte geben Sie das Datum im Format <strong>TT.MM.JJJJ</strong> ein. Zwei Ziffern für den Tag, Punkt, zwei
                Ziffern für den Monat, Punkt, vier Ziffern für das Jahr.
              </p>
            </small>
            <span v-if="!isValid('birthdate') && $v.birthdate.$dirty" class="text-sm text-error">
              <slot name="errorMessageBirthdate">Bitte geben Sie Ihren Geburtstag an</slot>
            </span>
          </div>

          <div class="input-field">
            <label class="text-base-medium mandatory" for="newPassword">
              <slot name="lblNewPassword">Neues Passwort</slot>
            </label>
            <ValidationIndicator :dirty="$v.newPassword.$dirty" :valid="!$v.newPassword.$invalid">
              <input
                id="newPassword"
                name="newPassword"
                type="password"
                required
                v-model="newPassword"
                @input="$v.newPassword.$touch"
                class="input"
                :class="{ error: !isValid('newPassword') }"
                placeholder="*********"
              />
            </ValidationIndicator>
            <span v-if="!isValid('newPassword') && $v.newPassword.$dirty" class="text-sm text-error">
              <slot name="errorMessagePasswortRules">Ihr Passwort entspricht nicht den Passwort-Regeln</slot>
            </span>
          </div>

          <div class="input-field">
            <label class="text-base-medium mandatory" for="newPasswordRepeat">
              <slot name="lblNewPasswordRepeat">Neues Passwort (Wiederholung)</slot>
            </label>
            <ValidationIndicator :dirty="$v.newPasswordRepeat.$dirty" :valid="!$v.newPasswordRepeat.$invalid">
              <input
                id="newPasswordRepeat"
                name="newPasswordRepeat"
                type="password"
                required
                v-model="newPasswordRepeat"
                @input="$v.newPasswordRepeat.$touch"
                class="input"
                :class="{ error: !isValid('newPasswordRepeat') }"
                placeholder="*********"
              />
            </ValidationIndicator>
            <span v-if="!isValid('newPasswordRepeat') && $v.newPasswordRepeat.$dirty" class="text-sm text-error">
              <slot name="errorMessagePasswordNotEqual">Ihre Passwörter stimmen nicht überein</slot>
            </span>
          </div>
          <slot name="txtAfter"></slot>
        </div>
      </fieldset>

      <button class="button button--primary" type="button" :disabled="loading" @click="save">
        <slot name="btnPasswordNext">weiter</slot>
      </button>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import { mapMutations, mapActions } from 'vuex'
import { validDate, validDateFormat } from '@/validators/date'
import isValid from '../../../../../mixins/isValid'
import ValidationIndicator from '@/components-v2/generic/ValidationIndicator.vue'

export default {
  name: 'ResetPasswordConfirmationPassword',
  data: function() {
    return {
      brand_: null,
      newPassword: '',
      newPasswordRepeat: '',
      birthdate: null,
      loading: false
    }
  },
  components: {
    ValidationIndicator
  },
  computed: {
    calendarSettings() {
      return this.$config.calendar.calendarSettings
    }
  },
  created() {
    this.brand_ = this.$store.getters.brand
  },
  mixins: [validationMixin, isValid],
  methods: {
    selectDate(ctx) {
      if (ctx.selectedDate) {
        this.birthdate = ctx.selectedFormatted
      }
    },
    async save() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.loading = true
      await this.resetPassword({
        password: this.newPassword,
        birthdate: this.birthdate
      })
      this.loading = false
    },
    ...mapActions('resetPassword', ['resetPassword']),
    ...mapMutations('resetPassword', ['finalizeProcess'])
  },
  validations() {
    return {
      newPassword: {
        required,
        passwordValidation: this.$config?.validation?.validatePassword
      },
      newPasswordRepeat: {
        required,
        sameAsPassword: sameAs('newPassword')
      },
      birthdate: {
        required,
        validDate,
        validDateFormat
      }
    }
  }
}
</script>
